import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SaveCodeBookImportPageMutationVariables = Types.Exact<{
  importId: Types.Scalars['uuid']['input'];
  pageNumber: Types.Scalars['Int']['input'];
  overrides: Types.Scalars['jsonb']['input'];
}>;


export type SaveCodeBookImportPageMutation = { __typename?: 'mutation_root', save_code_book_import_page?: { __typename?: 'SaveCodeBookImportPageOutput', saved: boolean } | null };


export const SaveCodeBookImportPageDocument = gql`
    mutation saveCodeBookImportPage($importId: uuid!, $pageNumber: Int!, $overrides: jsonb!) {
  save_code_book_import_page(
    input: {import_id: $importId, page_number: $pageNumber, overrides: $overrides}
  ) {
    saved
  }
}
    `;
export type SaveCodeBookImportPageMutationFn = Apollo.MutationFunction<SaveCodeBookImportPageMutation, SaveCodeBookImportPageMutationVariables>;

/**
 * __useSaveCodeBookImportPageMutation__
 *
 * To run a mutation, you first call `useSaveCodeBookImportPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCodeBookImportPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCodeBookImportPageMutation, { data, loading, error }] = useSaveCodeBookImportPageMutation({
 *   variables: {
 *      importId: // value for 'importId'
 *      pageNumber: // value for 'pageNumber'
 *      overrides: // value for 'overrides'
 *   },
 * });
 */
export function useSaveCodeBookImportPageMutation(baseOptions?: Apollo.MutationHookOptions<SaveCodeBookImportPageMutation, SaveCodeBookImportPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCodeBookImportPageMutation, SaveCodeBookImportPageMutationVariables>(SaveCodeBookImportPageDocument, options);
      }
export type SaveCodeBookImportPageMutationHookResult = ReturnType<typeof useSaveCodeBookImportPageMutation>;
export type SaveCodeBookImportPageMutationResult = Apollo.MutationResult<SaveCodeBookImportPageMutation>;
export type SaveCodeBookImportPageMutationOptions = Apollo.BaseMutationOptions<SaveCodeBookImportPageMutation, SaveCodeBookImportPageMutationVariables>;